import styled from "styled-components";
import { IMAGES } from "../../../constants/images";
import { useMap } from "../../../hooks/useMap";

function ZoomControls({ bearing }) {
  const map = useMap();

  const handleZoomIn = () => {
    map.zoomIn();
  };

  const handleZoomOut = () => {
    map.zoomOut();
  };

  const handleResetNorth = () => {
    map.easeTo({ bearing: 0, pitch: 0, duration: 500 });
  };

  return (
    <ZoomStyles>
      <button className="rotate" onClick={handleResetNorth}>
        <img src={IMAGES.PANORAME} alt="Panorame" style={{ transform: `rotate(${-bearing + 45}deg)` }} />
      </button>
      <div className="zoom">
        <button className="zoom-in" onClick={handleZoomIn}>
          <img src={IMAGES.PLUS} alt="Zoom In" />
        </button>
        <button className="zoom-out" onClick={handleZoomOut}>
          <img src={IMAGES.MINUS} alt="Zoom Out" />
        </button>
      </div>
    </ZoomStyles>
  );
}

const ZoomStyles = styled.div`
  display: flex;
  flex-direction: column;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 35px;
    height: 35px;
    background-color: #fff;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    color: rgba(0, 0, 255, 1);
    transition: background-color 0.3s ease;
    &:hover {
      background-color: #f5f5f5;
    }
  }

  .rotate {
    margin-bottom: 5px;

    img {
      margin-top: 2px;
      height: 16px;
    }
  }
  .zoom {
    margin: 0;
    display: flex;
    flex-direction: column;
    img {
      width: 18px;
    }
    .zoom-in {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
    .zoom-out {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }
  }
`;

export default ZoomControls;
